<template>
    <grid
        :isAutoHeight="true"
        :row-data="rowData"
        :is-search="false"
        :column-defs="columnDefs"
        grid-theme="ag-theme-alpine-compact"
        :pinnedBottomRowData="pinnedBottomRowData"
        :isAutoWidth="true"
        class="table-header-highlight"
    ></grid>
</template>

<script>
import api from '../../../../api';
import { Decimal } from 'decimal.js';
import { mapGetters } from 'vuex';
import { DAMAGE_PROTECTION_EDIT_CLAIM_ENDPOINT } from '../../../../endpoints';
import grid from '../../../generic/grid/grid.vue';

export default {
    components: { grid },
    name: 'UploadedDocumentationTable',
    data() {
        return {
            values: [],
        };
    },
    props: {
        rowData: {
            type: Array,
            default: () => [],
        },
        totalAttachmentSize: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        ...mapGetters('header', ['userIsAdmin']),
        columnDefs() {
            return [
                {
                    field: 'name',
                    headerName: 'Title',
                    minWidth: 250,
                    sortable: false,
                },
                {
                    field: 'description',
                    headerName: 'Description',
                    minWidth: 200,
                    sortable: false,

                    autoWidthExclude: true,
                },
                {
                    field: 'created',
                    headerName: 'Uploaded',
                    type: 'dateColumn',
                    minWidth: 120,
                    sortable: false,
                },
                {
                    field: 'size',
                    headerName: 'Size',
                    minWidth: 60,
                    sortable: false,

                    cellRenderer: ({ data }) =>
                        data &&
                        data.size &&
                        `${new Decimal(data.size).toFixed(
                            2,
                            Decimal.ROUND_HALF_EVEN
                        )} Mb`,
                },
                {
                    type: 'switchColumn',
                    field: 'attach',
                    headerName: 'Attach ?',
                    sortable: false,
                    hide: !this.userIsAdmin,
                    valueGetter: ({ data }) => data.attach,
                    cellRendererParams: {
                        onChange: async ({ node }, newValue) => {
                            try {
                                await api.put(
                                    `${DAMAGE_PROTECTION_EDIT_CLAIM_ENDPOINT(
                                        node.id
                                    )}attach-document/`,
                                    {
                                        attach: newValue,
                                    }
                                );
                                this.$emit('table-updated');
                            } catch (e) {
                                this.errorToast({
                                    text: `Could not attach document.`,
                                });
                            }
                        },
                        hideIfPinned: true,
                    },
                },
                {
                    field: 'link',
                    headerName: 'View',
                    minWidth: 100,

                    cellRenderer: ({ data, node }) =>
                        !node.rowPinned && data
                            ? `<a href="${data.link}" target="_blank">View</a>`
                            : '',
                },
            ];
        },
        pinnedBottomRowData() {
            return [
                {
                    name: this.totalAttachmentSize
                        ? `Total attachment size: ${new Decimal(
                              this.totalAttachmentSize
                          ).toFixed(2, Decimal.ROUND_HALF_EVEN)} Mb`
                        : '',
                },
            ];
        },
    },
};
</script>